import {Routes} from '@angular/router';

export const groupbuyingRecommendationRoutes: Routes = [
  {
    path: 'groupbuyingRecommendation',
    loadComponent: () => import('./groupbuying-recommendation.component').then(m => m.GroupbuyingRecommendationComponent),
    data: { title: '团购推荐管理' },
  },
];
